import { Utilities as utilities } from '@truckdown/framework';
import { ServiceStatus } from './ServiceStatus';
import { ServiceType } from './ServiceType';

export class Service {
    constructor(json?: any) {
        if (json) {
            this.id = utilities.json.getStringValue(json, 'id', '');
            this.name = utilities.json.getStringValue(json, 'n', '');
            this.code = utilities.json.getStringValue(json, 'cd', '');
            this.priority = utilities.json.getNumberValue(json, 'p', 999);

            this.status = utilities.json.getEnumValue(json, 's', ServiceStatus, ServiceStatus.Inactive);
            this.type = utilities.json.getEnumValue(json, 't', ServiceType, ServiceType.Service);

            this.tags = utilities.json.getArrayValue(json, (data) => {
                if (data && data != null) {
                    return data as string;
                }
                return null;
            }, 'ts', []);
            this.childServices = utilities.json.getArrayValue(json, (data) => {
                if (data && data != null) {
                    return data as string;
                }
                return null;
            }, 'cs', []);
            this.groupedServices = utilities.json.getArrayValue(json, (data) => {
                if (data && data != null) {
                    return data as string;
                }
                return null;
            }, 'gs', []);

            this.freeService = utilities.json.getBooleanValue(json, 'fs', false);
            this.hasData = utilities.json.getBooleanValue(json, 'hd', false);

            this.sites = utilities.json.getArrayValue(json, (data) => {
                if (data && data != null) {
                    return data as string;
                }
                return null;
            }, 'ss', []);

            this.iconId = utilities.json.getStringValue(json, 'icon');
            this.suppressSeo = utilities.json.getBooleanValue(json, 'seo', true);

            this.modifiedTime = utilities.json.getDateValue(json, 'mt', new Date());
            let createdUser = utilities.json.getStringValue(json, 'cu');
            if (createdUser != null) {
                this.createdUserId = createdUser;
            }
        }
    }

    id: string = '';
    code: string = '';
    name: string = '';
    priority: number = 999;
    status: ServiceStatus = ServiceStatus.Inactive;
    type: ServiceType = ServiceType.Service;
    tags: string[] = [];
    childServices: string[] = [];
    groupedServices: string[] = [];
    freeService: boolean = false;
    hasData: boolean = false;
    sites: string[] = [];
    iconId: string | null = null;
    suppressSeo: boolean = true;

    createdUserId?: string;
    modifiedTime: Date = new Date();
}